import React, { useEffect, useRef, useState } from "react";
import {
    MdKeyboardArrowDown, MdKeyboardArrowUp
} from "react-icons/md";
import CalendarRange from "../../../assets/img/date_range_icon.svg";
import TagPrice from "../../../assets/img/tag_price_icon.svg";
import styles from "./dropDown.module.scss";


export interface DropDownProps {
    children?: any;
    placeholder?: string;
    type: "date" | "price";
    className?: string;
}

export const TEST_ID = 'drop-down-testid';

export const DropDown: React.FC<DropDownProps> = ({
    children,
    placeholder,
    type,
    className,
}) => {
    const [isOpen, setOpen] = useState(false);
    const [items, setItem] = useState([]);
    const [selectedItem, setSelectedItem] = useState(null);

    const toggleDropdown = () => setOpen(!isOpen);

    // const handleItemClick = (id) => {
    //     selectedItem == id ? setSelectedItem(null) : setSelectedItem(id);
    // };

    const activeSlideRef = useRef(null);

    function handleClickOutside(event) {
        if (
            activeSlideRef &&
            !activeSlideRef?.current?.contains(event.target)
        ) {
            setOpen(false);
        }
    }

    useEffect(() => {
        if (!isOpen && activeSlideRef) {
            document.addEventListener("click", handleClickOutside);
        }

        return () => document.removeEventListener("click", handleClickOutside);
    }, []);

    return (
        <div data-testid={TEST_ID} ref={activeSlideRef} className={styles.box}>
            <div
                className={`${styles.dropdown} ${className} ${
                    isOpen ? `${styles.open}` : ""
                }`}
            >
                <div
                    className={styles.dropdown_header}
                    onClick={toggleDropdown}
                >
                    <div
                        className={styles.text}
                        style={
                            type === "price"
                                ? { fontSize: "12px" }
                                : { fontSize: "14px" }
                        }
                    >
                        {type === "price" ? (
                            <img src={TagPrice} alt="tag_price" style={{marginRight: '10px'}} />

                        ) : (
                            <img src={CalendarRange} alt="calendar" style={{marginRight: '10px'}} />

                        )}
                        <span>{placeholder}</span>
                    </div>
                    <div>
                        {isOpen ? (
                            <MdKeyboardArrowUp width={9} height={5.5} />
                        ) : (
                            <MdKeyboardArrowDown width={9} height={5.5} />
                        )}
                    </div>
                </div>
            </div>
            <div
                className={`${styles.dropdown_body} ${
                    isOpen ? `${styles.open}` : ""
                }`}
            >
                {children}
            </div>
        </div>
    );
};
